import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SubpageLayout from "@/components/SubpageLayout";
import { scrollToSection } from "@/App";

const SERVICES = [
  {
    slug: "implementering",
    title: "Implementering",
    text: "Når traumebevidsthed skal være mere end ny viden. Vi understøtter organisationer i at omsætte traumebevidste forståelser til konkret praksis og arbejder blandt andet med ledelse, organisering, faglige kulturer, sprog, relationer, arbejdsgange og rammer. Målet er en praksis, der både styrker kvaliteten for de mennesker, organisationen er sat i verden for, og bidrager til større faglig sikkerhed og mere bæredygtige arbejdspladser.",
    linkLabel: "Læs om implementering",
  },
  {
    slug: "kurser",
    title: "Kurser og undervisning",
    text: "Ny viden kan skabe nye perspektiver og handlemuligheder. Vi tilbyder kurser, oplæg og undervisningsforløb om traumer, traumeforståelse, traumeterapi og traumebevidst tilgang – fra grundlæggende traumeforståelse til specialiserede temaer og praksisnære redskaber. Undervisningen tilpasses målgruppe, faglighed og kontekst og har fokus på at gøre viden relevant og anvendelig i praksis.",
    linkLabel: "Se kurser og undervisning",
  },
  {
    slug: "supervision",
    title: "Supervision og faglig sparring",
    text: "Et rum for refleksion, forståelse og udvikling af faglig praksis. Supervision giver mulighed for at undersøge konkrete situationer, reaktioner, relationer og faglige dilemmaer – og på samme tid rette blikket mod de forståelser og betingelser, der former vores handlinger. Vi tilbyder supervision og faglig sparring til fagpersoner, teams og ledere.",
    linkLabel: "Læs om supervision og faglig sparring",
  },
];

const ViTilbyder = () => (
  <SubpageLayout overline="TRAUMEBEVIDST UDVIKLING" title="Vi tilbyder" art="/brand/phase-froe.png" testId="page-vi-tilbyder">
    <p className="text-base leading-loose text-[#2F3338]/85">
      Viden og forståelse kan sætte noget i bevægelse. Varig udvikling kræver ofte også, at ny
      viden kan omsættes til praksis og få plads i den virkelighed, mennesker og organisationer
      står i.
    </p>
    <p className="mt-6 text-base leading-loose text-[#2F3338]/85">
      Derfor tilbyder vi oplæg, foredrag, videns- og praksiskurser, supervision, faglig sparring
      samt støtte til implementering af traumebevidst tilgang.
    </p>
    <p className="mt-6 text-base leading-loose text-[#2F3338]/85">
      Det vigtigste er, at indholdet er relevant og anvendeligt i den sammenhæng, hvor det skal
      bruges. Derfor tilrettelægger vi gerne forløb med udgangspunkt i jeres behov, målgrupper og
      organisatoriske rammer.
    </p>
    <p className="mt-6 text-base leading-loose text-[#2F3338]/85">
      Nedenfor finder I eksempler på nogle af de kurser og forløb, vi tilbyder.
    </p>

    <div className="mt-16 space-y-14">
      {SERVICES.map((service) => (
        <section
          key={service.slug}
          data-testid={`service-block-${service.slug}`}
          className="border-b border-[#D6C2A6]/70 pb-14 last:border-b-0"
        >
          <h3 className="font-serif text-2xl text-[#3F5A47] sm:text-3xl">{service.title}</h3>
          <p className="mt-5 text-base leading-loose text-[#2F3338]/85">{service.text}</p>
          <Link
            to={`/vi-tilbyder/${service.slug}`}
            data-testid={`service-link-${service.slug}`}
            className="group mt-6 inline-flex items-center gap-2 text-sm font-medium text-[#3F5A47] transition-colors duration-300 hover:text-[#B46A45]"
          >
            {service.linkLabel}
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </section>
      ))}
    </div>

    <section className="mt-20">
      <h2 className="font-serif text-2xl text-[#3F5A47] sm:text-3xl">Ikke altid enten – eller</h2>
      <p className="mt-6 text-base leading-loose text-[#2F3338]/85">
        Et kursus kan skabe ny viden. Supervision kan understøtte refleksion og faglig udvikling.
        Implementeringsstøtte kan hjælpe den nye forståelse med at få plads i organisationens
        rammer og praksis. Derfor kan vores tilbud også kombineres i længere udviklingsforløb.
      </p>
      <p className="mt-6 text-base leading-loose text-[#2F3338]/85">
        <button
          onClick={() => scrollToSection("#kontakt")}
          data-testid="vi-tilbyder-kontakt-link"
          className="font-medium text-[#3F5A47] underline decoration-[#B46A45]/50 underline-offset-4 transition-colors duration-300 hover:text-[#B46A45]"
        >
          Kontakt os
        </button>
        , hvis I vil drøfte, hvad der giver mening hos jer.
      </p>
    </section>
  </SubpageLayout>
);

export default ViTilbyder;
